var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"load"}},[_c('div',[_vm._v("G")]),_c('div',[_vm._v("N")]),_c('div',[_vm._v("I")]),_c('div',[_vm._v("D")]),_c('div',[_vm._v("A")]),_c('div',[_vm._v("O")]),_c('div',[_vm._v("L")])])
}]

export { render, staticRenderFns }